import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store/index';

import './script';
import 'popper.js';
import 'bootstrap';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';

import MlHeader from './components/MlHeader.vue';
import MlFooter from './components/MlFooter.vue';
import Alert from './components/elements/alert/Alert.vue';
import VueSlideUpDown from 'vue-slide-up-down';
import vSelect from 'vue-select'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import './registerServiceWorker';
import './helpers/fas';
import './helpers/far';
import './helpers/fab';
import 'viewerjs/dist/viewer.css';
import 'vue-select/dist/vue-select.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);

import VueContentLoading from 'vue-content-loading';

Vue.component('vcl', VueContentLoading)

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.component('ml-header', MlHeader);
Vue.component('ml-footer', MlFooter);
Vue.component('ml-alert', Alert);
Vue.component('vue-slide-up-down', VueSlideUpDown)
Vue.component('v-select', vSelect)

Vue.use(VueProgressBar, { color: '#c26ad6', failedColor: '#fc595e', thickness: '3px' });

Vue.config.productionTip = false;
moment.locale('id');

Vue.directive('uppercase', {
	twoWay: true,
	bind: function(el) {
		addEventListener('input', () => {
			el.value = el.value.toUpperCase()
		})
	},
})

Vue.filter('toKg', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});
	if( parseInt(value) >= 1000 ){
		return formatter.format(parseInt(value)/1000) + ' kg';
	} else {
		return formatter.format(parseInt(value)) + ' gr';
	}
});

Vue.filter('toNumber', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});
	return formatter.format(parseInt(value));
});

Vue.filter('toRupiah', function(value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});
	return 'Rp ' + formatter.format(parseInt(value));
});

Vue.filter('tanggal', function(value) {
	var date = moment(value).format('DD MMMM YYYY HH:mm:ss')
	if(date == 'Invalid date'){
		return '-'
	} else {
		return date
	}
});

Vue.filter('hariTanggalJam', function(value) {
	var date = moment(value).format('dddd, DD MMMM YYYY HH:mm:ss')
	if(date == 'Invalid date'){
		return '-'
	} else {
		return date
	}
});

Vue.filter('hariTanggal', function(value) {
	var date = moment(value).format('dddd, DD MMMM YYYY')
	if(date == 'Invalid date'){
		return '-'
	} else {
		return date
	}
});

Vue.filter('two_digits', (value) => {
	if (value < 0) {
		return '00';
	}
	if (value.toString().length <= 1) {
		return `0${value}`;
	}
	return value;
});

Vue.filter('shipping', (value) => {
	if (value == '0') {
		return 'Pickup';
	} else {
		return 'Shipping Courier';
	}
});

Vue.filter('paymentMethod', (value) => {
	if (value == 0) {
		return 'Bonus'
	} else if (value == 1) {
		return 'Bank Transfer'
	} else {
		return 'Virtual Account'
	}
});

Vue.filter('toStatus', (value) => {
	let status = [
	'Menunggu Pembayaran',
	'Menunggu Approval Pembayaran',
	'Transaksi Dibatalkan',
	'Pembayaran Sukses',
	'Diproses Mobile Counter',
	'Dibatalkan Mobile Counter',
	'Sudah Dikirim',
	'Sudah Diambil',
	'Pengajuan Return',
	'Selesai',
	'Return Diterima',
	'Return Ditolak',
	'Return Pengajuan Banding',
	'Sudah Dikirim Oleh Pembeli',
	'Barang Diterima & Diproses',
	'Barang Pengganti Dikirim'
	]

	return status[value];
});

Vue.mixin({
	methods: {
		onlyNumber($event) {
			let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
				$event.preventDefault();
			}
		},
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')